export const generateTooltipKey = (contributorId) => {
  const randomNumber = Math.floor(Math.random() * 100) + 1;
  return `tooltip-${contributorId}-${randomNumber}`;
};
